import React, { FC, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { MentionedUser } from './MentionTextarea';
import './mention-access-modal.scss';

interface MentionAccessModalProps {
  show: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  usersNeedingAccess: MentionedUser[];
}

const MentionAccessModal: FC<MentionAccessModalProps> = ({
  show,
  onClose,
  onConfirm,
  usersNeedingAccess,
}) => {
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    setLoading(true);
    try {
      await onConfirm();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      dialogClassName='mention-access-modal'
    >
      <Modal.Header>
        <Modal.Title>Grant access to mentioned users?</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p className='modal-description'>
          The following users don't have access to this conversation. They will
          be given <strong>write access</strong> so they can see and respond to
          your message.
        </p>

        <ul className='users-list'>
          {usersNeedingAccess.map((user) => (
            <li key={user.userId} className='user-item'>
              {user.displayName}
            </li>
          ))}
        </ul>
      </Modal.Body>

      <Modal.Footer>
        <button className='cancel-btn' onClick={onClose} disabled={loading}>
          Cancel
        </button>
        <button
          className='confirm-btn'
          onClick={handleConfirm}
          disabled={loading}
        >
          {loading ? 'Granting access...' : 'Grant access & send'}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default MentionAccessModal;
